import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import {
  AlertsCard,
  AlertsTitle,
  AlertsGrid,
  AlertCard,
  AlertContent,
  AlertTitle,
  AlertMessage,
} from './styles';
import { SECTION_TITLES } from './constants';
import { AlertsSectionProps } from './types';

const AlertsSection: React.FC<AlertsSectionProps> = ({ alerts = [], isLoading = false }) => {
  const navigate = useNavigate();

  if (isLoading || alerts.length === 0) {
    return null;
  }

  return (
    <AlertsCard>
      <AlertsTitle level={4}>{SECTION_TITLES.ALERTS}</AlertsTitle>
      <AlertsGrid>
        {alerts.map((alert) => (
          <AlertCard key={alert.id} $severity={alert.severity}>
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              {alert.severity === 'error' ? (
                <ExclamationCircleOutlined style={{ color: '#F56565', marginRight: 12 }} />
              ) : (
                <InfoCircleOutlined style={{ color: '#ED8936', marginRight: 12 }} />
              )}
              <AlertContent>
                <AlertTitle>
                  {alert.title}
                  {alert.count !== undefined && ` (${alert.count})`}
                </AlertTitle>
                <AlertMessage>{alert.message}</AlertMessage>
              </AlertContent>
            </div>
            {alert.action && (
              <Button
                type="text"
                size="small"
                onClick={() => navigate(alert.action!.route)}
                style={{ marginLeft: 12 }}
              >
                View
              </Button>
            )}
          </AlertCard>
        ))}
      </AlertsGrid>
    </AlertsCard>
  );
};

export default AlertsSection;
